import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

/** Người đang được "Xem như" ở server. Chỉ nằm trong bộ nhớ: tải lại trang là tắt. */
let viewAsId: string | null = null;

/** Bật/tắt header `x-view-as` cho mọi request PostgREST và Edge Function. Tắt có hiệu lực ngay ở request kế tiếp. */
export function setViewAs(id: string | null): void { viewAsId = id; }

export const isViewingAs = (): boolean => viewAsId !== null;

/** Chỉ `/rest/v1` và `/functions/v1`; `/auth/v1` không bao giờ mang danh tính khác. */
const carriesViewAs = (input: RequestInfo | URL): boolean => {
  const target = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
  return target.includes('/rest/v1/') || target.includes('/functions/v1/');
};

export function viewAsFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  if (!viewAsId || !carriesViewAs(input)) return fetch(input, init);
  const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
  headers.set('x-view-as', viewAsId);
  return fetch(input, { ...init, headers });
}

export const supabase = createClient(url, anonKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
  global: { fetch: viewAsFetch },
});
